import { HttpMethod, tryFetch, type HttpResponse } from '@/services/http'
import type { ClientErrorCode } from '../types/client.enums'
import type {
  ClientAction,
  ClientCarrier,
  ClientCountry,
  ClientDimension,
  ClientServiceGroup,
  ClientViewResponse,
  ClientZipZone,
} from '../models/client.models'

const BASE_URL = import.meta.env.VITE_MAIN_BASE_URL

const getClientViews = async (): Promise<HttpResponse<ClientViewResponse, ClientErrorCode>> =>
  await tryFetch<ClientViewResponse, ClientErrorCode>(HttpMethod.Get, BASE_URL, 'client/views')

const getClientActions = async (): Promise<HttpResponse<ClientAction[], ClientErrorCode>> =>
  await tryFetch<ClientAction[], ClientErrorCode>(HttpMethod.Get, BASE_URL, 'client/actions', {
    view: true,
  })

const getClientCarriers = async (): Promise<HttpResponse<ClientCarrier[], ClientErrorCode>> =>
  await tryFetch<ClientCarrier[], ClientErrorCode>(HttpMethod.Get, BASE_URL, 'client/carriers', {
    view: true,
  })

const getClientCountries = async (): Promise<HttpResponse<ClientCountry[], ClientErrorCode>> =>
  await tryFetch<ClientCountry[], ClientErrorCode>(HttpMethod.Get, BASE_URL, 'client/countries', {
    view: true,
  })

const getClientDimensions = async (): Promise<
  HttpResponse<Record<number, ClientDimension>, ClientErrorCode>
> =>
  await tryFetch<Record<number, ClientDimension>, ClientErrorCode>(
    HttpMethod.Get,
    BASE_URL,
    'client/dimensions',
    {
      view: true,
    },
  )

const getClientServiceGroups = async (): Promise<
  HttpResponse<ClientServiceGroup[], ClientErrorCode>
> =>
  await tryFetch<ClientServiceGroup[], ClientErrorCode>(
    HttpMethod.Get,
    BASE_URL,
    'client/service-groups',
    {
      view: true,
    },
  )

const getClientZipZones = async (): Promise<HttpResponse<ClientZipZone[], ClientErrorCode>> =>
  await tryFetch<ClientZipZone[], ClientErrorCode>(HttpMethod.Get, BASE_URL, 'client/zip-zones', {
    view: true,
  })

const getClientSettings = async (
  body: number[],
): Promise<HttpResponse<{ [id: number]: string }, ClientErrorCode>> =>
  await tryFetch<{ [id: number]: string }, ClientErrorCode>(
    HttpMethod.Post,
    BASE_URL,
    'client/settings',
    { view: true, body },
  )

export const clientApi = {
  getClientViews,
  getClientActions,
  getClientCarriers,
  getClientCountries,
  getClientDimensions,
  getClientServiceGroups,
  getClientZipZones,
  getClientSettings,
}
